import RefreshIcon from "../images/RefreshIcon.mjs";

/**
 * App icon for refresh action
 * @desc NOTE: if accessing to backend consider using AppReloadIcon
 * @see {AppReloadIcon}
 * @see {GlyphIcon}
 * @see {RefreshIcon}
 */
const AppRefreshIcon = class extends RefreshIcon {};

export default AppRefreshIcon;